module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/franchising/network-doveit.5601b3cd22dfc31b371e9b08b4908e0e.jpg";